const wishlistTriggers = [...document.querySelectorAll(".js-wishlist-trigger")];

wishlistTriggers.map((trigger) => {
     trigger.addEventListener('click', (e) => {
         e.preventDefault();
     });
});